import React, { FC, ReactElement, ReactNode } from 'react';

import { Container, ContainerProps } from '@lglp/components';
import { RichTextBlock } from 'prismic-richtext';

import { asHtml } from './asHtml';
import styles from './RichText.module.scss';

export const RichText: FC<RichTextProps> = ({
  as,
  body,
  multiline = true,
  prefix,
  className,
  ...rest
}) => {
  if (!body) {
    return null;
  }

  if (!multiline) {
    return asHtml(body, prefix, {
      className: [styles.richText, className],
      ...rest,
    }) as unknown as ReactElement;
  }

  return (
    <Container className={[styles.richText, className]} {...rest}>
      {asHtml(body, prefix)}
    </Container>
  );
};

export type RichTextProps = ContainerProps & {
  body: RichTextBlock[];
  multiline?: boolean;
  prefix?: ReactNode;
};
